import { RefDataAccessor } from "@libs/api/ref-data/RefDataAccessor.ts";
import { IDrugsGateway } from "@libs/gateways/drugs/DrugsGateway.interface.ts";
import { Ref } from "@stores/types/ref.type.ts";

export class DrugRef implements Ref<keyof DrugRef> {
  constructor(private gateway: IDrugsGateway) {}

  pbsListings = new RefDataAccessor(() => this.gateway.getPbsListings());
}
